import { FC } from "react"
import cx from "classnames"
import Modal, { ModalProps } from "@/components/Modal"
import CancelButton from "@/components/OutlineButton/CancelButton"
import DeleteButton from "@/components/Button/DeleteButton"
import { useDeleteOrganization } from "@/pages/Organizations/hooks/useDeleteOrganization"
import type { Organization } from "@/types/entities/organization"

type Props = {
  className?: string
  data?: Organization
} & ModalProps

const DeleteOrganizationModal: FC<Props> = ({
  className,
  open,
  onClose,
  data,
  ...rest
}: Props) => {
  const {
    deleteOrganization,
    response: { isLoading },
  } = useDeleteOrganization()
  if (!data) {
    return null
  }
  const handleSubmit = async () => {
    await deleteOrganization(data._id)
    onClose && onClose()
  }
  return (
    <Modal
      title="Delete Organization"
      open={open}
      onClose={onClose}
      onSubmit={data.isMaster ? undefined : handleSubmit}
      className={cx("", className)}
      actions={
        <div className="flex gap-4">
          <CancelButton onClick={onClose} disabled={isLoading} />
          {!data.isMaster && <DeleteButton disabled={isLoading} />}
        </div>
      }
      {...rest}
    >
      {data.isMaster ? (
        <span className="text-base leading-6">
          This is your master org and cannot be deleted.
        </span>
      ) : (
        <span className="text-base leading-6">
          Are you sure you want to delete{" "}
          <span className="font-semibold">“{data.name}”</span>?
        </span>
      )}
    </Modal>
  )
}

export default DeleteOrganizationModal
